import { withInstall } from '@element-plus/utils/with-install'

import Affix from './src/affix.vue'

export const ElAffix = withInstall(Affix)
export default ElAffix

export * from './src/affix'
